import React, { useEffect, useState } from 'react';
import { Box, SvgIcon } from '@agilize/components-core';
import { Description, Title } from './ZendeskChatButton.styles';

const ZendeskChatButton = () => {
  const openZendeskChat = () => {
    if (!window['zE']) {
      return;
    }
    window['zE']('messenger', 'open');
  };
  return (
    <Box p={1} data-testid="open-zendesk-button" onClick={openZendeskChat} display="flex" alignItems="center">
      <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/chat.svg`} />
      <Box ml={2}>
        <Title>Converse com a gente</Title>
        <Box pb={1}>
          <Description>Disponível entre 8:00 e 18:00 segunda à quinta</Description>
        </Box>
        <Description>Disponível entre 8:00 e 17:00 sexta</Description>
      </Box>
    </Box>
  );
};

export default ZendeskChatButton;
